<section class="hero">
  <div class="hero-inner">
    <h1 class="hero-title">NW Hub</h1>
    <p class="hero-tagline">
      Tools, data &amp; reference for <strong>Neverwinter</strong> &mdash;
      build planners, combat sims, mechanics calculators, gear &amp; mount lists, and more.
    </p>
    <div class="hero-actions">
      <a class="hero-cta primary" routerLink="/characters">
        <mat-icon>manage_accounts</mat-icon>
        <span>Build a character</span>
      </a>
      <a class="hero-cta secondary" routerLink="/logparser">
        <mat-icon>analytics</mat-icon>
        <span>Parse a log</span>
      </a>
      <a class="hero-cta secondary" routerLink="/rainer">
        <mat-icon>tune</mat-icon>
        <span>Rainer&rsquo;s Tools</span>
      </a>
    </div>
  </div>
</section>

<ng-container *ngFor="let section of sections">
  <section class="home-section" *ngIf="isSectionVisible(section.cards)" [id]="'sec-' + section.key">
    <header class="section-header" [class]="'accent-' + section.cards[0].accent">
      <mat-icon class="section-icon">{{ section.icon }}</mat-icon>
      <div class="section-titles">
        <h2 class="section-title">{{ section.title }}</h2>
        <p class="section-blurb" *ngIf="section.blurb">{{ section.blurb }}</p>
      </div>
    </header>

    <div class="card-grid">
      <ng-container *ngFor="let card of section.cards">
        <a *ngIf="isCardVisible(card)"
           class="home-card"
           [class.featured]="card.featured"
           [class]="'home-card accent-' + card.accent + (card.featured ? ' featured' : '')"
           [routerLink]="card.routerLink">
          <div class="card-head">
            <mat-icon class="card-icon">{{ card.icon }}</mat-icon>
            <span class="card-label">{{ card.label }}</span>
            <mat-icon *ngIf="card.labsOnly" class="labs-tag" title="Labs feature">science</mat-icon>
          </div>
          <p class="card-desc">{{ card.desc }}</p>
          <div class="card-links" *ngIf="card.links?.length">
            <ng-container *ngFor="let link of card.links">
              <a *ngIf="isLinkVisible(link)"
                 class="card-link-chip"
                 [routerLink]="link.routerLink"
                 [queryParams]="link.queryParams || null"
                 (click)="$event.stopPropagation()">
                {{ link.label }}
              </a>
            </ng-container>
          </div>
        </a>
      </ng-container>
    </div>
  </section>
</ng-container>

<section class="news-teaser" *ngIf="latestNews">
  <header class="teaser-header">
    <mat-icon>fiber_new</mat-icon>
    <h2>Recently added &middot; {{ latestNews.date }}</h2>
    <a class="teaser-more" routerLink="/about" [queryParams]="{ tab: 'whats-new' }">See full What&rsquo;s New &rarr;</a>
  </header>
  <ul class="teaser-list">
    <li *ngFor="let item of latestNews.items.slice(0, 4)">{{ item }}</li>
  </ul>
</section>
